import React, { Component } from "react";
import Layout from "./../../global/Layout";
import { StyledContainer } from "./styles";
import { toggleClientRoot } from "./../toggleClientRoute";

import {
  Title,
  SubtitleWrapper,
  Grid,
  GridItem
} from "./styles";

import { Link } from "./../../makealist/components/StyledLink";
import Heading from "./../../makealist/components/DetailHeading";
import routeNames from "./../../utilities/server/routeNames";
import Author from "./../../makealist/components/Author/small";
import { StyledHelpText } from "./../../makealist/routes/common/styles";
import { makeLink } from "./../../makealist/utils/link";

class MakeList extends Component {
  render() {
    let { clientContext, context } = this.props;
    let { isMobile } = clientContext;
    let { settings, lists, listsByCategory } = context.data;

    let { title, messageLineOne, messageLineTwo } = settings.strings.makealist;

    const isClient = typeof window === "object";
    toggleClientRoot();
    if (
      lists !== null &&
      lists.data !== undefined &&
      lists.data.length > 0 &&
      listsByCategory !== undefined
    ) {
      const getSections = (lists, listsByCategory) => {
        let sectionsData = lists.data.reduce((accumulator, item, index) => {
          return {
            ...accumulator,
            [item.topic]:
              listsByCategory && listsByCategory[index]
                ? listsByCategory[index]
                : null,
          };
        }, {});
        let sections = {};

        Object.keys(sectionsData)
          .sort()
          .forEach(function (key) {
            sections[key] = sectionsData[key];
          });
        return sections;
      };

      let sections = getSections(lists, listsByCategory);

      return (
        <Layout context={context} clientContext={clientContext}>
          <StyledContainer>
            <Title>{title}</Title>
            <StyledHelpText>{messageLineOne}</StyledHelpText>
            <StyledHelpText>{messageLineTwo}</StyledHelpText>

            {sections &&
              Object.entries(sections).map(([header, lists]) => {
                return (
                  <>
                    <SubtitleWrapper>
                      <Heading fullWidth>{header}</Heading>
                    </SubtitleWrapper>
                    <Grid>
                      {lists !== undefined &&
                        lists !== null &&
                        lists.map((item, index) => {
                          let path = makeLink(routeNames.createlist, {
                            state: {
                              topic: item.title,
                              queue: item.movieQueue,
                            },
                          });
                          return (
                            <Link id={item.slug} to={path} key={item.slug}>
                              <GridItem isMobile={isMobile}>
                                <Author noName {...item} clientContext={clientContext} context={context} />
                              </GridItem>
                            </Link>
                          );
                        })}
                    </Grid>
                  </>
                );
              })}
          </StyledContainer>
        </Layout>
      );
    }
    return null;
    
  }
}

// MakeList.propTypes = {
//   /**
//    Client side variables
//   */
//   clientContext: PropTypes.object,
//   /**
//    Server side variables
//   */
//   context: PropTypes.object.isRequired,
// };

// export default (props) => {
//   return <MakeList {...props} />;
// };

export default (props) => {
  return <MakeList {...props} />;
};
